import { GridCellParams } from "@mui/x-data-grid";
import { useIntl } from "react-intl";

import { AddressLink } from "@dzambalaorg/mui-scanner";
import { formatEther } from "@framework/exchange";

// prettier-ignore
export const leaderBoardColumnsCreator = (formatMessage: ReturnType<typeof useIntl>["formatMessage"]) =>  [
  {
    field: "id",
    headerName: formatMessage({ id: "form.labels.id" }),
    sortable: true,
    flex: 0.3
  },
  {
    field: "account",
    headerName: formatMessage({ id: "form.labels.account" }),
    sortable: false,
    renderCell: (params: GridCellParams<any, string>) => {
      return (
        <AddressLink address={params.value} />
      );
    },
    flex: 3,
    minWidth: 360
  },
  {
    field: "amount",
    headerName: formatMessage({ id: "form.labels.amount" }),
    sortable: true,
    valueFormatter: (value: string) => formatEther(value),
    flex: 1,
    minWidth: 100
  }
]
